// ============================================================================
// DirBadge — direction chip (LONG / SHORT).
//
// Three sizes (sm, md, lg) tuned so the chip rides comfortably alongside a
// ticker symbol at hero, card, and row scales. Uses the green/red dim
// surface + bordered semantic colour so it reads on every background tier
// without a fill swap.
// ============================================================================

import Icon from './Icon.jsx';
import { TERMS } from '../../utils/terms';

const SIZE_MAP = {
  sm: { f: 9,  px: 6,  py: 2, ic: 10 },
  md: { f: 10, px: 8,  py: 3, ic: 11 },
  lg: { f: 12, px: 11, py: 5, ic: 14 },
};

export default function DirBadge({ dir, size = 'md' }) {
  const isLong = dir === 'LONG' || dir === 'BUY';
  const label  = dir === 'BUY' ? 'BUY' : dir === 'SHORT' ? 'SHORT' : (isLong ? 'LONG' : (dir || 'SHORT'));
  const S = SIZE_MAP[size] || SIZE_MAP.md;
  return (
    <span title={TERMS.direction} style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 3,
      fontWeight: 800,
      letterSpacing: '0.04em',
      fontSize: S.f,
      padding: `${S.py}px ${S.px}px`,
      borderRadius: 'var(--r-sm)',
      background: isLong ? 'var(--green-dim)' : 'var(--red-dim)',
      color:      isLong ? 'var(--green-soft)' : 'var(--red-soft)',
      border:     `1px solid ${isLong ? 'rgba(34,197,94,0.28)' : 'rgba(239,68,68,0.28)'}`,
      whiteSpace: 'nowrap',
      cursor: 'help',
    }}>
      <Icon name={isLong ? 'arrowUR' : 'arrowDR'} size={S.ic} stroke={2.6} />
      {label}
    </span>
  );
}
